import styled from 'styled-components';
import { theme } from '../styles/theme';
import { BaseButton, Flex } from '../styles';

// Componentes específicos da página que não existem no tema
export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: ${theme.spacing[3]};
  align-items: center;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 300px;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: ${theme.spacing[3]};
  top: 50%;
  transform: translateY(-50%);
  color: ${theme.colors.gray[400]};
`;

export const UsersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: ${theme.spacing[5]};
  margin-bottom: ${theme.spacing[8]};
`;

export const UserHeader = styled(Flex)`
  align-items: center;
  gap: ${theme.spacing[4]};
  margin-bottom: ${theme.spacing[4]};
`;

export const UserAvatar = styled.div<{ type: 'admin' | 'operador' }>`
  width: 48px;
  height: 48px;
  background: ${props => props.type === 'admin'
    ? `linear-gradient(135deg, ${theme.colors.warning[400]} 0%, ${theme.colors.warning[600]} 100%)`
    : `linear-gradient(135deg, ${theme.colors.primary[500]} 0%, ${theme.colors.primary[700]} 100%)`};
  border-radius: ${theme.borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.text.inverse};
  font-weight: ${theme.typography.fontWeight.semibold};
  font-size: ${theme.typography.fontSize.base};
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const UserName = styled.h3`
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing[1]} 0;
`;

export const UserEmail = styled.p`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.sm};
  margin: 0;
`;

export const UserMeta = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing[4]};
`;

export const UserRole = styled.span<{ type: 'admin' | 'operador' }>`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing[1]};
  padding: ${theme.spacing[1]} ${theme.spacing[2]};
  background: ${props => props.type === 'admin' ? theme.colors.warning[100] : theme.colors.primary[100]};
  color: ${props => props.type === 'admin' ? theme.colors.warning[700] : theme.colors.primary[700]};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
`;

export const UserStatus = styled.span<{ ativo: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing[1]};
  padding: ${theme.spacing[1]} ${theme.spacing[2]};
  background: ${props => props.ativo ? theme.colors.success[100] : theme.colors.error[100]};
  color: ${props => props.ativo ? theme.colors.success[700] : theme.colors.error[700]};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
`;

export const UserActions = styled(Flex)`
  gap: ${theme.spacing[2]};
`;

export const ActionButton = styled(BaseButton) <{ variant?: 'danger' | 'warning' | 'success' }>`
  width: 36px;
  height: 36px;
  min-width: 36px;
  padding: 0;
  
  ${props => {
    switch (props.variant) {
      case 'danger':
        return `
          background: ${theme.colors.error[100]};
          color: ${theme.colors.error[600]};
          &:hover:not(:disabled) { 
            background: ${theme.colors.error[200]}; 
            color: ${theme.colors.error[700]};
          }
        `;
      case 'warning':
        return `
          background: ${theme.colors.warning[100]};
          color: ${theme.colors.warning[600]};
          &:hover:not(:disabled) { 
            background: ${theme.colors.warning[200]}; 
            color: ${theme.colors.warning[700]};
          }
        `;
      case 'success':
        return `
          background: ${theme.colors.success[100]};
          color: ${theme.colors.success[600]};
          &:hover:not(:disabled) { 
            background: ${theme.colors.success[200]}; 
            color: ${theme.colors.success[700]};
          }
        `;
      default:
        return `
          background: ${theme.colors.gray[100]};
          color: ${theme.colors.gray[600]};
          &:hover:not(:disabled) { 
            background: ${theme.colors.gray[200]}; 
            color: ${theme.colors.gray[700]};
          }
        `;
    }
  }}

  svg {
    width: 16px;
    height: 16px;
  }
`;
